
import * as lscache from 'lscache';

export class StorageService {

    public get = (key: string): string | Object => {
        return lscache.get(key);
    }

    public set = (key: string, value: Object | string, expiry?: number): boolean => {
        lscache.setExpiryMilliseconds(1);
        return lscache.set(key, value, expiry);
    }

    public flush = (): void => {
        return lscache.flush();
    }
}